/* eslint-disable prettier/prettier */
import { SnackbarVariant } from '@eas/common-web';
import { MessageType } from './message-type';

const REGISTER: MessageType &
  MessageType<'OVZ_FACILITY_MULTIPLE_LIVESTOCK_SOURCES'> = {
  SUCCESS: [
    'Zdroj minimální vzdálenosti byl úspěšně zaregistrován.',
    SnackbarVariant.SUCCESS,
  ],
  ERROR: ['Chyba při registraci.', SnackbarVariant.ERROR],
  OVZ_FACILITY_MULTIPLE_LIVESTOCK_SOURCES: [
    'Nelze přiřadit více zdrojů k provozovně OVZ pouze pro hospodářská zvířata.',
    SnackbarVariant.ERROR,
  ],
};

const UPDATE: MessageType &
  MessageType<'OVZ_FACILITY_NOT_MINIMAL_DISTANCES'> = {
  OVZ_FACILITY_NOT_MINIMAL_DISTANCES: [
    'Pro editaci zdroje je nutné nejdříve v detailu provozovny OVZ v části "Identifikátory" označit atribut "Alespoň jeden zdroj na provozovně podléhá § 12a zákona o ochraně ovzduší".',
    SnackbarVariant.ERROR,
  ],

  ERROR: ['Chyba při ukládání změn', SnackbarVariant.ERROR],
  SUCCESS: [
    'Zdroj minimální vzdálenosti byl úspěšně upraven.',
    SnackbarVariant.SUCCESS,
  ],
};

export default {
  REGISTER,
  UPDATE,
};
